const handleMaintenanceStatusModal = {
  text1: 'Do you really want to',
  text2: 'this maintenance?',
  confirm_title: 'MAINTENANCE',
  cancel: 'CANCEL',
  send: 'SEND',
  complete: 'COMPLETE',
  reactivate: 'REACTIVATE'
};

export default handleMaintenanceStatusModal;
